import { query } from '@warp-drive/utilities/json-api';
import type { ReportScheduleRun } from '../data/resources/report-schedule-run.type.ts';

const RESOURCE_PATH = 'api/v2/report-schedule-runs';

/**
 * report-schedule-runs is a read-only v2 JSONAPI resource (/api/v2/report-schedule-runs,
 * tio-api RFC 080). Force a reload every read (NOT SkipCache): each row's
 * `downloadUrl` is a short-lived signed link, so a soft-TTL cache hit would
 * hand back an expired URL. `reload` refetches fresh every time AND upserts
 * into the cache, keeping `content.data` materialized records — SkipCache would
 * return raw resource objects and break every `run.ranAt`/`.downloadUrl` read.
 */
export function reportScheduleRunsQuery(params: Record<string, string | number> = {}) {
  return {
    ...query<ReportScheduleRun>('report-schedule-run', params, { resourcePath: RESOURCE_PATH }),
    cacheOptions: { reload: true },
  };
}
